var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _c("span", [
        _vm._v(_vm._s(_vm.$t("AidApplication.Title_BudgetaryEstimate")))
      ])
    ]),
    _vm._v(" "),
    _vm.budgetaryEstimate
      ? _c("div", [
          _vm.hasProcuration
            ? _c(
                "div",
                [
                  _vm.isAy
                    ? _c("attachment-row", {
                        attrs: {
                          title: "BudgetaryEstimate.Attachment",
                          instructionsKey:
                            "BudgetaryEstimate.Attachment_Instructions",
                          attachment: _vm.attachment,
                          index: 1
                        },
                        model: {
                          value: _vm.attachment,
                          callback: function($$v) {
                            _vm.attachment = $$v
                          },
                          expression: "attachment"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isSupportApartments
                    ? _c("support-apartments-budgetary-estimate-view", {
                        attrs: {
                          item: _vm.investment,
                          type: _vm.bAidType,
                          profitsNumericInputRules: _vm.profitsNumericInputRules
                        }
                      })
                    : _vm.isPremisesRenovationOrImprovement
                    ? _c("premises-budgetary-estimate-view", {
                        attrs: {
                          item: _vm.investment,
                          type: _vm.bAidType,
                          profitsNumericInputRules: _vm.profitsNumericInputRules
                        }
                      })
                    : _vm.isICT
                    ? _c("ict-budgetary-estimate-view", {
                        attrs: {
                          item: _vm.investment,
                          type: _vm.bAidType,
                          profitsNumericInputRules: _vm.profitsNumericInputRules
                        }
                      })
                    : _c(
                        "div",
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.$t("BudgetaryEstimate.Profits.Title"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("estimates-control", {
                            attrs: {
                              id: "profit-breakdown",
                              titleKey: "BudgetaryEstimate.Profits.Breakdown",
                              tableKey: "BudgetaryEstimate.Profits.Entry",
                              addButtonKey: "BudgetaryEstimate.Profits.AddNew",
                              addButtonTooltip:
                                "BudgetaryEstimate.Profits.AddNew_Instructions",
                              createEstimate: _vm.createProfitEstimate,
                              options: _vm.otherProfitOptions,
                              showActions: true,
                              showColumnTotals: true,
                              showRowTotals: true,
                              required: true,
                              numericInputRules: _vm.profitsNumericInputRules
                            },
                            model: {
                              value: _vm.profitEstimates,
                              callback: function($$v) {
                                _vm.profitEstimates = $$v
                              },
                              expression: "profitEstimates"
                            }
                          }),
                          _vm._v(" "),
                          _vm.showGrantorsAndPurposes
                            ? _c("text-area-row", {
                                attrs: {
                                  title:
                                    "BudgetaryEstimate.Profits.GrantorsAndPurposes",
                                  id: "grantorsandpurposes",
                                  required: true,
                                  maxLength: 500,
                                  rows: 7
                                },
                                model: {
                                  value: _vm.profits.grantorsAndPurposes,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.profits,
                                      "grantorsAndPurposes",
                                      $$v
                                    )
                                  },
                                  expression: "profits.grantorsAndPurposes"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("h3", [
                            _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.Expenses")))
                          ]),
                          _vm._v(" "),
                          _c("personnel-expenses-control", {
                            attrs: {
                              personnelExpenses: _vm.personnelExpenses,
                              features: _vm.features
                            }
                          }),
                          _vm._v(" "),
                          _c("premises-control", {
                            attrs: {
                              premises: _vm.premises,
                              applicationYear: _vm.applicationYear
                            },
                            on: {
                              "expense-changed": _vm.setPremiseTotalExpenses
                            }
                          }),
                          _vm._v(" "),
                          _vm.premisesSelected
                            ? _c("other-expenses-control", {
                                attrs: { otherExpenses: _vm.otherExpenses }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("estimates-and-details-control", {
                            attrs: {
                              id: "operational-expenses",
                              titleKey:
                                "BudgetaryEstimate.OperationalExpenses.Breakdown",
                              tableKey:
                                "BudgetaryEstimate.OperationalExpenses.Entry",
                              instructionsKey:
                                "BudgetaryEstimate.OperationalExpenses.Breakdown_Instructions",
                              showColumnTotals: true,
                              showRowTotals: true,
                              required: true
                            },
                            model: {
                              value: _vm.operationalExpenseWrappers,
                              callback: function($$v) {
                                _vm.operationalExpenseWrappers = $$v
                              },
                              expression: "operationalExpenseWrappers"
                            }
                          }),
                          _vm._v(" "),
                          !_vm.isAy && !_vm.isPlaceOpen
                            ? _c("general-expenses-control", {
                                attrs: { generalExpenses: _vm.generalExpenses }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isAy && !_vm.isPlaceOpen
                            ? _c("delegation-control", {
                                attrs: {
                                  title: "BudgetaryEstimate.Delegation.Title",
                                  delegatedAid: _vm.delegatedAid,
                                  createEstimate: _vm.createDelegationEstimate
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "h3",
                            [
                              _c("plain-text-control", {
                                attrs: {
                                  title: "BudgetaryEstimate.Total.Title"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("estimates-control", {
                            attrs: {
                              id: "total-summary",
                              titleKey: "BudgetaryEstimate.Total.Title",
                              tableKey: "BudgetaryEstimate.Total.Category",
                              srOnlyTitle: true,
                              showRowTotals: true,
                              showColumnTotals: true,
                              totalRowHeader:
                                "BudgetaryEstimate.Total.Difference"
                            },
                            model: {
                              value: _vm.totalSummary,
                              callback: function($$v) {
                                _vm.totalSummary = $$v
                              },
                              expression: "totalSummary"
                            }
                          })
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c("text-area-row", {
                    attrs: {
                      title: "BudgetaryEstimate.MoreInformation",
                      id: "moreInformation",
                      required: false,
                      maxLength: 1000,
                      rows: 5
                    },
                    model: {
                      value: _vm.budgetaryEstimate.moreInformation,
                      callback: function($$v) {
                        _vm.$set(_vm.budgetaryEstimate, "moreInformation", $$v)
                      },
                      expression: "budgetaryEstimate.moreInformation"
                    }
                  })
                ],
                1
              )
            : _c("div", [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("BudgetaryEstimate.ProcurationOnly")))
                ])
              ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }